import { styled } from 'dripsy';
import { observer } from 'mobx-react-lite';
import React, { Fragment, forwardRef } from 'react';
import { View } from 'react-native';

import { BaseText } from '../common/BaseText';
import { Line } from '../common/Line';
import { Touchable } from '../common/Touchable';
import {
  IPopoverProps,
  Popover,
  PopoverPositionEnum,
} from './Popover';
import { IPopoverManagerProps } from '@hooks';

const TouchableContainer = styled(Touchable)({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  py: '$4',
});

const Label = styled(BaseText)({
  variant: 'text.medium',
});

const MenuContainer = styled(View)({
  minWidth: 132,
  bg: '$background0',
  px: '$5',
  py: '$4',
  borderRadius: 12,
});

interface IActiveContainerProps {
  active: boolean;
}

const ActiveContainer = styled(View)(
  (props: IActiveContainerProps) => ({
    flexGrow: 1,
    pl: '$4',
    py: '$2',
    bg: props.active ? '$primary80' : null,
    borderRadius: 8,
  }),
);

type PickerItemType<T = any> = {
  value: T;
  title: string;
};

export interface IPickerPopoverProps
  extends Omit<IPopoverProps, 'children'> {
  onSelect(item: PickerItemType): void;
  options: PickerItemType[];
  selectedValue: any;
  children: React.ReactNode;
}

export const PickerPopover = observer(
  forwardRef<IPopoverManagerProps, IPickerPopoverProps>(
    (
      { children, options, onSelect, selectedValue, ...props },
      ref,
    ) => {
      return (
        <Popover
          ref={ref}
          position={PopoverPositionEnum.Top}
          offset={35}
          {...props}
        >
          {children}

          <MenuContainer>
            {options.map((option, index) => {
              const active = selectedValue === option.value;
              const isFistItem = index === 0;

              return (
                <Fragment key={index}>
                  {!isFistItem && <Line />}
                  <TouchableContainer
                    onPress={() => onSelect(option)}
                  >
                    <ActiveContainer active={active}>
                      <Label>{option.title}</Label>
                    </ActiveContainer>
                  </TouchableContainer>
                </Fragment>
              );
            })}
          </MenuContainer>
        </Popover>
      );
    },
  ),
);
